interface WithOptionalAvatarUrl {
  avatar_url?: string | null;
}

export type RelationValue<T> = T | T[] | null;

const uniqueTruthyIds = (ids: string[]): string[] => Array.from(new Set(ids.filter(Boolean)));

export const normalizeSingleRelation = <T>(relation: RelationValue<T>): T | null => {
  if (!relation) {
    return null;
  }

  if (Array.isArray(relation)) {
    return relation[0] || null;
  }

  return relation;
};

export const normalizeAuthorRelation = <T extends WithOptionalAvatarUrl>(
  relation: RelationValue<T>
): (T & { avatar_url: string | null }) | null => {
  const author = normalizeSingleRelation(relation);

  if (!author) {
    return null;
  }

  return {
    ...author,
    avatar_url: author.avatar_url ?? null,
  };
};

export const trimToNull = (value: string | null | undefined): string | null => {
  return value?.trim() || null;
};

export const buildFavoriteUpsertRows = (recipeIds: string[], authorId: number) => {
  const uniqueRecipeIds = uniqueTruthyIds(recipeIds);

  return uniqueRecipeIds.map((recipeId) => ({
    recipe_id: recipeId,
    author_id: authorId,
  }));
};

export const orderByReferenceIds = <T extends { id: string }>(
  items: T[],
  orderedIds: string[]
): T[] => {
  const orderMap = new Map(uniqueTruthyIds(orderedIds).map((itemId, index) => [itemId, index]));

  return [...items].sort((left, right) => {
    return (orderMap.get(left.id) ?? Number.MAX_SAFE_INTEGER)
      - (orderMap.get(right.id) ?? Number.MAX_SAFE_INTEGER);
  });
};
